module.exports = __webpack_public_path__ + "img/ms.094ad248.svg";